<script>
export default {
    name: "MedicalFileAppointments",

    props: {
        appointments: Array,
    },

    methods: {

        printMedicalFile() {
            window.print();
        },
    }
}
</script>
<template>
    <div class="w-full flex-wrap">
       <div class="w-full p-1">
           <div class="p-1 w-full bg-indigo-300 rounded-t-md">
               <h5 class="font-bold text-white text-sm">
                   Visit #{{ $route.query.visitNo }}</h5>
           </div>
           <div class="w-full border-r-2 border-l-2 border-b-2 border-indigo-300 rounded-b p-2">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-sm">
                        <tr>
                            <th class="p-tiny">Date</th>
                            <th class="p-tiny">Visit No</th>
                            <th class="p-tiny">Encounter</th>
                            <th class="p-tiny">Doctor</th>
                            <th class="p-tiny">Clinic</th>
                            <th class="p-tiny">Appointment Date</th>
                            <th class="p-tiny">Start Time</th>
                            <th class="p-tiny">End Time</th>
                            <th class="p-tiny">Comment</th>
                            <th class="p-tiny">Recorded By</th>
                            <th class="p-tiny">Action</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs bg-gray-100">
                        <tr v-for="(appointment,idx) in appointments" :key="idx">
                            <td class="p-tiny">{{ appointment.txnDate | dateFormat }}</td>
                            <td class="p-tiny">{{ appointment.visitNo }}</td>
                            <td class="p-tiny">{{ appointment.encounterID || `-` }}</td>
                            <td class="p-tiny">{{ appointment.doctor }}</td>
                            <td class="p-tiny">{{ appointment.clinic }}</td>
                            <td class="p-tiny">{{ appointment.appointmentDate | dateFormat }}</td>
                            <td class="p-tiny">{{ appointment.startTime }}</td>
                            <td class="p-tiny">{{ appointment.endTime }}</td>
                            <td class="p-tiny break-words">{{ appointment.comment || `-` }}</td>
                            <td class="p-tiny">{{ appointment.userName }}</td>
                            <td class="p-tiny">
                                <router-link
                                      v-if="
                                            ($root.formatLowercase(appointment.userName) ==
                                            $root.formatLowercase($root.username)) ||
                                            $root.checkAuth('AdminEditMedicalFile')
                                          " 
                                      :to="{
                                        name: `med-f.visit.index`,
                                        params: {
                                          patientID: $route.params.patientID,
                                          visitNo: $route.params.visitNo,
                                        },
                                        query: {
                                          encounterID: appointment.encounterID,
                                          from: $route.query.from,
                                        },
                                      }" 
                                      class="btn-sm btn-warning text-xs text-white rounded">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
           </div>
       </div> 
       <div class="w-full p-1 text-right">
            <button 
                @click.prevent="printMedicalFile"
                class="btn-sm btn-primary text-xs hide--print">
                    <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
